<template>
  <div ref="container">
    <NsCarousel
      :style="carouselStyle"
      :min="3"
      :max="5"
      :spacing="10"
      :vertical-overflow-amount="200"
      :unique-reset-key="localSkus.length"
      :hide-controls="!showControls"
      wrap
    >
      <div v-for="sku in localSkus" :key="sku" :class="$style.productCard">
        <NsProductCard
          :sku="sku"
          :forcesv="forcesv"
          :hide-exclusive-icon="hideExclusiveIcon"
          :hide-exclusive-text-on-mobile="hideExclusiveTextOnMobile"
          :hide-favorites="hideFavorites"
          :hide-sku="hideSku"
          :no-action="noAction"
        />
      </div>
      <!-- Show two more empty Cards on mobile to scroll to end with min="3" on NsCarousel -->
      <template v-if="phabletAndDown">
        <div v-for="num in 2" :key="num" :class="$style.productCard" />
      </template>
    </NsCarousel>
  </div>
</template>

<script>
import { PopularProductsService } from "@nuskin/ns-product";
import { getRecommendations } from "@nuskin/product-recommendation";
import { NsCarousel } from "@nuskin/design-components";

import NsProductCard from "./NsProductCard.vue";

// MIN_WIDTH equals left and right controls plus 3 product cards at 230px each
const MIN_WIDTH = 800;

/**
 * NsProductCarousel
 *
 */

export default {
  name: "NsProductCarousel",
  components: {
    NsCarousel,
    NsProductCard
  },
  props: {
    skus: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: ""
    },
    forcesv: Boolean,
    hideExclusiveIcon: Boolean,
    hideExclusiveTextOnMobile: Boolean,
    hideFavorites: Boolean,
    hideSku: Boolean,
    noAction: Boolean
  },
  data() {
    return {
      localSkus: this.skus,
      showControls: true,
      carouselStyle: ""
    };
  },
  computed: {
    phabletAndDown() {
      return this.$mq === "phablet" || this.$mq === "mobile";
    }
  },
  watch: {
    skus(value) {
      if (!this.type) {
        this.localSkus = value;
      }
    },
    type: {
      immediate: true,
      handler(newVal) {
        this.setSkusByType(newVal);
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.checkMinWindowSize);
    this.$nextTick(() => {
      this.checkMinWindowSize();
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.checkMinWindowSize);
  },
  methods: {
    checkMinWindowSize() {
      if (
        this.$refs.container &&
        this.$refs.container.clientWidth < MIN_WIDTH
      ) {
        this.showControls = false;

        // Carousel should stop centering at MIN_WIDTH minus controls (90px)
        if (this.$refs.container.clientWidth < MIN_WIDTH - 90) {
          this.carouselStyle = "justify-content: flex-start;";
        } else {
          this.carouselStyle = "";
        }
      } else {
        this.showControls = true;
      }
    },
    setSkusByType(type) {
      switch (type) {
        case "recommended":
          this.setSkusWithRecommendedProducts();
          break;
        case "popular":
          this.setSkusWithPopularProducts();
          break;
        default:
          this.localSkus = this.skus;
      }
    },
    async setSkusWithRecommendedProducts() {
      try {
        let recommendedProducts = await getRecommendations();
        if (recommendedProducts) {
          this.localSkus = recommendedProducts.map(
            recommendation => recommendation.sku
          );
        }
      } catch (err) {
        console.log(err);
        this.localSkus = [];
      }
    },
    async setSkusWithPopularProducts() {
      const popularProducts = await PopularProductsService.getPopularProducts();
      if (popularProducts) {
        this.localSkus = popularProducts.Items.map(
          popularProduct => popularProduct.sku
        );
      } else {
        this.localSkus = [];
      }
    }
  }
};
</script>
<style lang="scss" module>
.productCard {
  width: 230px;
  min-height: 200px;
}

@media (min-width: 1024px) {
  .productCard {
    width: 315px;
  }
}
</style>
